import { WIDGET_ARE_LOADING, WIDGET_HAVE_ERROR, WIDGET_FETCH_DATA_SUCCESS } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function widgetReducer (state = initialState, action) {
    switch (action.type) {
        case WIDGET_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case WIDGET_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case WIDGET_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.widget,
                loading:false,
            }

        default:
            return state;
    }
}